import React from "react";

/** No entrance animation - content is rendered plainly for maximum reliability. */
export const Reveal = ({ children, className = "" }) => <div className={className}>{children}</div>;

export const Label = ({ children, testId }) => (
  <span className="label-kicker" data-testid={testId}>
    {children}
  </span>
);

export const Section = ({ id, children, className = "", dark = false, testId }) => (
  <section
    id={id}
    data-testid={testId}
    className={`section-pad relative ${dark ? "on-dark" : ""} ${className}`}
  >
    {children}
  </section>
);

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-[1240px] px-6 md:px-10 ${className}`}>{children}</div>
);

export const CtaButton = ({ children, href = "#kontakt", testId, className = "" }) => (
  <a
    href={href}
    data-testid={testId}
    className={`btn-solid inline-flex items-center justify-center px-8 py-4 text-[15px] font-bold tracking-[0.04em] uppercase ${className}`}
  >
    <span>{children}</span>
  </a>
);

export const AccentH2 = ({ children, className = "", testId }) => {
  const text = String(children).trim();
  const words = text.split(" ");
  const last = words[words.length - 1];
  const tail = last.length <= 5 && words.length > 2 ? words.slice(-2).join(" ") : last;
  const head = text.slice(0, text.length - tail.length);
  return (
    <h2 className={className} data-testid={testId}>
      {head}
      <span style={{ color: "var(--accent)" }}>{tail}</span>
    </h2>
  );
};
